import { render, staticRenderFns } from "./VacationsCalendar.vue?vue&type=template&id=765bd55a&"
import script from "./VacationsCalendar.vue?vue&type=script&lang=js&"
export * from "./VacationsCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports